import { usePubSub } from 'hooks/pubsub/usePubSub'

interface ImportacaoCnesListenerProps {
  municipio: ID
  onImportacaoMessage(): void
}

export const ImportacaoCnesListener = (props: ImportacaoCnesListenerProps) => {
  const { municipio, onImportacaoMessage } = props

  usePubSub({ topic: `/importar-cnes/${municipio}`, onMessage: onImportacaoMessage })
  return null
}
